export const formatBrand = (brand: string | null | undefined): string => {
  if (!brand) return 'Eneas';

  const withoutPrefix = brand.replace(/^[A-Z]{2}_/, '');

  return withoutPrefix.charAt(0).toUpperCase() + withoutPrefix.slice(1).toLowerCase();
};
